import { set } from '../utils/token'
import { setLocalStore } from '../utils/localStore'
/* eslint-disable */
export const CommunicationMutations = {
  UPDATE_TAG (state, tag) {
    state.tag = tag
  }
}
export const MessageMutations = {
  UPDATE_COUNT (state, count) {
    state.newMessageCount = count
  },
  UPDATE_STAR_CIRCLE_COUNT(state, count) {
    state.newStarcircleCount = count
  },
  UPDATE_TALE_COUNT(state, count) {
    state.newTaleCount = count
   }
}
export const UserMutations = {
  UPDATE_USER(state, user) {
    state.user = user
  },
  UPDATE_AVATER_USER (state, avatar) {
    state.user.avatar = avatar
  },
  UPDATE_SIGN_USER (state, signName) {
    state.user.signName = signName
  },
  UPDATE_NICKNAME_USER (state, nickName) {
    state.user.nickName = nickName
  },
  UPDATE_GENDER (state, gender) {
    state.user.gender = gender
  }
}
export const RefeshMutations = {
  UPDATE_DOWN_REFRESH (state, down) {
    state.downRefresh = down
  }
}
export const TabBarMutations = {
  UPDATE_TABBAR_INFDEX (state, index) {
    set('tabIndex', index)
    state.tabIndex = index
  }
}
export const DynamicTabBarMutations = {
  DYNAMIC_UPDATE_TABBAR_INFDEX (state, index) {
    set('dynamicTabIndex', index)
    state.dynamicTabIndex = index
  }
}
export const RouterMutations = {
  UPDATE_ROUTER(state, router) {
    setLocalStore('router', router)
    Object.assign(state, router)
    // state.router = router
  }
}
export const TarBarModuleAuthMutations = {
  UPDATE_AUTH(state, auth) {
    // setLocalStore('tabbarAuth', auth)
    set('tabbarAuth', auth)
    Object.assign(state, auth)
  }
}
export const CenterModuleAuthMutations = {
  UPDATE_AUTH(state, auth) {
    // setLocalStore('tabbarAuth', auth)
    set('centerAuth', auth)
    Object.assign(state, auth)
  }
}
export const HomeModuleAuthMutations = {
  UPDATE_AUTH(state, auth) {
    // setLocalStore('tabbarAuth', auth)
    set('homeAuth', auth)
    Object.assign(state, auth)
  }
}
export const DynamicModuleAuthMutations = {
  UPDATE_AUTH(state, auth) {
    // setLocalStore('tabbarAuth', auth)
    set('dynamicAuth', auth)
    Object.assign(state, auth)
  }
}
export const MakeComplainsModuleAuthMutations = {
  UPDATE_AUTH(state, auth) {
    // setLocalStore('tabbarAuth', auth)
    set('messageAuth', auth)
    Object.assign(state, auth)
  }
}
export const RefiningModuleAuthMutations = {
  UPDATE_AUTH(state, auth) {
    // setLocalStore('tabbarAuth', auth)
    set('refiningAuth', auth)
    Object.assign(state, auth)
  }
}
export const CalendarModuleAuthMutations = {
  UPDATE_AUTH(state, auth) {
    // setLocalStore('tabbarAuth', auth)
    set('calendarAuth', auth)
    Object.assign(state, auth)
  }
}
// 新增
export const HotTopicListMutations = {
  UPDATE_HOT_TOPICS(state,auth) {
    state.HotTopic = auth
  }
}
export const BrowseCoordMutations = {
  UPDATE_BROWSE_COORD_FIND_SCROLL (state,data) {
    state.findScroll = data
  },
  UPDATE_FIND_LIST_COUNT (state,data) {
    state.findListCount = data
  },
  UPDATE_DYNAMIC_SCROLL (state,data) {
    state.dynamicScroll = data
  }
}